export function createDrawingContextMenuItems(drawing, hasClipboard, labels, callbacks) {
    const items = [
        { key: "copy", label: labels.copy, onSelect: callbacks.copySelectedDrawing },
        { key: "paste", label: labels.paste, onSelect: callbacks.pasteCopiedDrawing, disabled: !hasClipboard },
        { key: "duplicate", label: labels.duplicate, onSelect: callbacks.duplicateSelected },
        { key: "sep1", label: "", onSelect: () => { }, type: "separator" },
        { key: "lock", label: drawing.locked ? labels.unlock : labels.lock, onSelect: () => callbacks.toggleSelectedLock(!drawing.locked) },
        { key: "hide", label: drawing.visible === false ? labels.show : labels.hide, onSelect: () => callbacks.toggleSelectedVisible(drawing.visible !== false) },
        { key: "sep2", label: "", onSelect: () => { }, type: "separator" },
        { key: "front", label: labels.bringToFront, onSelect: callbacks.bringSelectedToFront },
        { key: "forward", label: labels.bringForward, onSelect: callbacks.bringSelectedForward },
        { key: "backward", label: labels.sendBackward, onSelect: callbacks.sendSelectedBackward },
        { key: "back", label: labels.sendToBack, onSelect: callbacks.sendSelectedToBack },
    ];
    if (drawing.groupId) {
        items.push({ key: "sep3", label: "", onSelect: () => { }, type: "separator" }, {
            key: "selectGroup",
            label: labels.selectGroup,
            onSelect: () => callbacks.selectGroup?.(drawing.groupId),
        }, {
            key: "deleteGroup",
            label: labels.deleteGroup,
            onSelect: () => callbacks.deleteGroup?.(drawing.groupId),
            danger: true,
        });
    }
    return items;
}
/**
 * P3-b: canvas-level menu (empty-chart right-click, no drawing selection).
 * Single clipboard-aware Paste action; alerts/tool submenus attach here in Phase 4.
 */
export function createCanvasContextMenuItems(hasClipboard, labels, callbacks) {
    const items = [
        { key: "paste", label: labels.paste, onSelect: callbacks.pasteCopiedDrawing, disabled: !hasClipboard },
    ];
    if (labels.toggleFavoritesBar && callbacks.toggleFavoritesBar) {
        items.push({ key: "sep-fav", label: "", onSelect: () => { }, type: "separator" }, { key: "toggleFavoritesBar", label: labels.toggleFavoritesBar, onSelect: callbacks.toggleFavoritesBar });
    }
    return items;
}
